import { cn } from '@latitude/token-utils';

import type { SVGProps } from '../../types';

export const SelectVaultIllustration = (props: SVGProps) => {
  const { className, ...restProps } = props;

  return (
    <svg
      className={cn('text-color-ref-primary-primary-50', className)}
      height="96"
      fill="none"
      width="132"
      data-testid="select-vault-illustration"
      viewBox="0 0 132 96"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <g clipPath="url(#clip0_5780_220963)">
        <path
          d="M90.4493 7.12891L131.508 7.12891V3.8748L90.4493 3.8748V7.12891Z"
          stroke="white"
          strokeWidth="2.29076"
          strokeMiterlimit="10"
        />
        <path
          d="M90.4508 14.1328L116.289 14.1328V10.8787L90.4508 10.8787V14.1328Z"
          stroke="white"
          strokeWidth="2.29076"
          strokeMiterlimit="10"
        />
        <path
          d="M11.2539 33.6663V30.3477H77.9975V92.8906H11.2539V90.6691V33.6663Z"
          fill="white"
        />
        <path
          d="M25.5336 91.9531H18.7695V95.9966H25.5336V91.9531Z"
          fill="white"
        />
        <path
          d="M69.5804 91.9531H62.8164V95.9966H69.5804V91.9531Z"
          fill="white"
        />
        <path
          d="M71.6517 36.2734H17.5938V86.4776H71.6517V36.2734Z"
          fill="black"
          stroke="white"
          strokeWidth="2.29076"
          strokeMiterlimit="10"
        />
        <path
          d="M72.6517 56.0781H18.5938V66.317H72.6517V56.0781Z"
          fill="black"
          stroke="white"
          strokeWidth="2.29076"
          strokeMiterlimit="10"
        />
        <path
          d="M105.308 66.2305C105.308 73.4759 99.4625 79.3487 92.2513 79.3487H62.9273C55.7161 79.3487 49.8711 73.4759 49.8711 66.2305"
          stroke="white"
          strokeWidth="2.29076"
          strokeMiterlimit="10"
        />
        <path
          d="M80.3341 0H63.9403C62.5472 0 61.418 1.13464 61.418 2.53428V56.2432C61.418 57.6429 62.5472 58.7775 63.9403 58.7775H80.3341C81.7271 58.7775 82.8564 57.6429 82.8564 56.2432V2.53428C82.8564 1.13464 81.7271 0 80.3341 0Z"
          fill="currentColor"
        />
        <path
          d="M72.1388 55.3415C76.3016 55.3415 79.6761 51.9509 79.6761 47.7684C79.6761 43.5859 76.3016 40.1953 72.1388 40.1953C67.9761 40.1953 64.6016 43.5859 64.6016 47.7684C64.6016 51.9509 67.9761 55.3415 72.1388 55.3415Z"
          stroke="black"
          strokeWidth="2.29076"
          strokeMiterlimit="10"
        />
        <path
          d="M75.2798 51.4564V50.7837C75.2798 49.0413 73.8742 47.6289 72.1399 47.6289C70.4057 47.6289 69 49.0413 69 50.7837V51.4564H75.2798Z"
          fill="black"
        />
        <path
          d="M72.139 47.7231C73.2578 47.7231 74.1648 46.8118 74.1648 45.6877C74.1648 44.5636 73.2578 43.6523 72.139 43.6523C71.0202 43.6523 70.1133 44.5636 70.1133 45.6877C70.1133 46.8118 71.0202 47.7231 72.139 47.7231Z"
          fill="black"
        />
        <path
          d="M72.1388 36.9625C76.3016 36.9625 79.6761 33.572 79.6761 29.3895C79.6761 25.207 76.3016 21.8164 72.1388 21.8164C67.9761 21.8164 64.6016 25.207 64.6016 29.3895C64.6016 33.572 67.9761 36.9625 72.1388 36.9625Z"
          stroke="black"
          strokeWidth="2.29076"
          strokeMiterlimit="10"
        />
        <path
          d="M75.2798 33.0775V32.4048C75.2798 30.6624 73.8742 29.25 72.1399 29.25C70.4057 29.25 69 30.6624 69 32.4048V33.0775H75.2798Z"
          fill="black"
        />
        <path
          d="M72.139 29.3481C73.2578 29.3481 74.1648 28.4368 74.1648 27.3127C74.1648 26.1886 73.2578 25.2773 72.139 25.2773C71.0202 25.2773 70.1133 26.1886 70.1133 27.3127C70.1133 28.4368 71.0202 29.3481 72.139 29.3481Z"
          fill="black"
        />
        <path
          d="M72.1388 18.6539C76.3016 18.6539 79.6761 15.2634 79.6761 11.0809C79.6761 6.89839 76.3016 3.50781 72.1388 3.50781C67.9761 3.50781 64.6016 6.89839 64.6016 11.0809C64.6016 15.2634 67.9761 18.6539 72.1388 18.6539Z"
          stroke="black"
          strokeWidth="2.29076"
          strokeMiterlimit="10"
        />
        <path
          d="M75.2798 14.7689V14.0962C75.2798 12.3538 73.8742 10.9414 72.1399 10.9414C70.4057 10.9414 69 12.3538 69 14.0962V14.7689H75.2798Z"
          fill="black"
        />
        <path
          d="M72.139 11.0395C73.2578 11.0395 74.1648 10.1282 74.1648 9.00412C74.1648 7.88002 73.2578 6.96875 72.139 6.96875C71.0202 6.96875 70.1133 7.88002 70.1133 9.00412C70.1133 10.1282 71.0202 11.0395 72.139 11.0395Z"
          fill="black"
        />
        <path
          d="M27.6194 75.447C30.7717 75.447 33.3261 72.8804 33.3261 69.7157C33.3261 66.5509 30.7717 63.9844 27.6194 63.9844H5.70422C2.55442 63.9844 0 66.5509 0 69.7157C0 72.8804 2.55442 75.447 5.70422 75.447H27.6194Z"
          fill="currentColor"
        />
        <path
          d="M27.6194 59.8923C30.7717 59.8923 33.3261 57.3257 33.3261 54.161C33.3261 50.9962 30.7717 48.4297 27.6194 48.4297H5.70422C2.55442 48.4297 0 50.9962 0 54.161C0 57.3257 2.55442 59.8923 5.70422 59.8923H27.6194Z"
          fill="currentColor"
        />
        <path
          d="M26.6165 71.0742H15.082"
          stroke="white"
          strokeWidth="1.14538"
          strokeMiterlimit="10"
        />
        <path
          d="M26.6165 68.3594H15.082"
          stroke="white"
          strokeWidth="1.14538"
          strokeMiterlimit="10"
        />
        <path
          d="M9.55297 72.6251C11.1247 72.6251 12.3989 71.3449 12.3989 69.7657C12.3989 68.1865 11.1247 66.9062 9.55297 66.9062C7.9812 66.9062 6.70703 68.1865 6.70703 69.7657C6.70703 71.3449 7.9812 72.6251 9.55297 72.6251Z"
          stroke="white"
          strokeWidth="1.14538"
          strokeMiterlimit="10"
        />
        <path
          d="M10.7427 71.1595V70.9063C10.7427 70.2485 10.2116 69.7148 9.5569 69.7148C8.90224 69.7148 8.37109 70.2485 8.37109 70.9063V71.1595H10.7427Z"
          fill="white"
        />
        <path
          d="M9.5549 69.6561C9.97785 69.6561 10.3207 69.3116 10.3207 68.8867C10.3207 68.4617 9.97785 68.1172 9.5549 68.1172C9.13194 68.1172 8.78906 68.4617 8.78906 68.8867C8.78906 69.3116 9.13194 69.6561 9.5549 69.6561Z"
          fill="white"
        />
        <path
          d="M26.6165 55.4688H15.082"
          stroke="white"
          strokeWidth="1.14538"
          strokeMiterlimit="10"
        />
        <path
          d="M26.6165 52.7539H15.082"
          stroke="white"
          strokeWidth="1.14538"
          strokeMiterlimit="10"
        />
        <path
          d="M9.55297 57.0197C11.1247 57.0197 12.3989 55.7395 12.3989 54.1602C12.3989 52.581 11.1247 51.3008 9.55297 51.3008C7.9812 51.3008 6.70703 52.581 6.70703 54.1602C6.70703 55.7395 7.9812 57.0197 9.55297 57.0197Z"
          stroke="white"
          strokeWidth="1.14538"
          strokeMiterlimit="10"
        />
        <path
          d="M10.7427 55.554V55.3008C10.7427 54.643 10.2116 54.1094 9.5569 54.1094C8.90224 54.1094 8.37109 54.643 8.37109 55.3008V55.554H10.7427Z"
          fill="white"
        />
        <path
          d="M9.5549 54.0507C9.97785 54.0507 10.3207 53.7062 10.3207 53.2812C10.3207 52.8562 9.97785 52.5117 9.5549 52.5117C9.13194 52.5117 8.78906 52.8562 8.78906 53.2812C8.78906 53.7062 9.13194 54.0507 9.5549 54.0507Z"
          fill="white"
        />
        <path
          d="M30.8185 50.9269C33.6004 50.9269 35.8557 48.661 35.8557 45.8658C35.8557 43.0706 33.6004 40.8047 30.8185 40.8047C28.0365 40.8047 25.7812 43.0706 25.7812 45.8658C25.7812 48.661 28.0365 50.9269 30.8185 50.9269Z"
          fill="white"
        />
        <path
          d="M30.8203 43.5156V48.2144"
          stroke="black"
          strokeWidth="2.29076"
          strokeMiterlimit="10"
        />
        <path
          d="M33.157 45.8672H28.4805"
          stroke="black"
          strokeWidth="2.29076"
          strokeMiterlimit="10"
        />
        <path
          d="M122.469 21.7188H88.7969V66.1842H122.469V21.7188Z"
          stroke="white"
          strokeWidth="2.29076"
          strokeMiterlimit="10"
        />
        <path
          d="M93.2266 30.832H99.9708"
          stroke="currentColor"
          strokeWidth="2.29076"
          strokeMiterlimit="10"
        />
        <path
          d="M101.465 43.1016H116.658"
          stroke="white"
          strokeWidth="2.29076"
          strokeMiterlimit="10"
        />
        <path
          d="M101.465 45.9531H116.658"
          stroke="white"
          strokeWidth="2.29076"
          strokeMiterlimit="10"
        />
        <path
          d="M101.465 48.8086H116.658"
          stroke="white"
          strokeWidth="2.29076"
          strokeMiterlimit="10"
        />
        <path
          d="M101.465 51.6602H116.658"
          stroke="white"
          strokeWidth="2.29076"
          strokeMiterlimit="10"
        />
        <path
          d="M101.465 54.5156H116.658"
          stroke="white"
          strokeWidth="2.29076"
          strokeMiterlimit="10"
        />
        <path
          d="M101.465 57.3672H116.658"
          stroke="white"
          strokeWidth="2.29076"
          strokeMiterlimit="10"
        />
        <path
          d="M101.465 60.2227H116.658"
          stroke="white"
          strokeWidth="2.29076"
          strokeMiterlimit="10"
        />
        <path
          d="M110.977 31.9019L112.894 33.828L116.656 30.1172"
          stroke="currentColor"
          strokeWidth="2.29076"
          strokeMiterlimit="10"
        />
        <path
          d="M90.2734 24.1836H93.6456"
          stroke="currentColor"
          strokeWidth="2.29076"
          strokeMiterlimit="10"
        />
      </g>
      <defs>
        <clipPath id="clip0_5780_220963">
          <rect width="132" height="96" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
